import * as React from 'react'
import styled from 'styled-components'

import { Spinner } from './Spinner'

import * as glyphs from '../icons/glyphs'
import * as imageUploader from '../styles/imageUploader'
import * as S from '../styles'

export type MiniImageUploaderProps = Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'onChange'> & {
  className?: string
  disabled?: boolean
  error?: React.ReactNode
  id?: string
  loading?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onDrop: (event: React.DragEvent<HTMLLabelElement>) => void
  onRemove: (event: React.MouseEvent<HTMLButtonElement>) => void
  previewSrc?: string
} & Omit<imageUploader.WrapperProps, '$active' | '$errored' | '$loading' | 'disabled'>

function MiniImageUploaderComponent({
  className,
  disabled = false,
  error,
  id,
  loading = false,
  onChange,
  onDrop,
  onRemove,
  previewSrc,
  ...labelProps
}: MiniImageUploaderProps): React.ReactElement<MiniImageUploaderProps> {
  const stableId = React.useId()
  const [active, setAsActive] = React.useState(false)

  return (
    <imageUploader.MiniWrapper
      $active={active}
      className={className}
      disabled={disabled}
      $errored={Boolean(error)}
      $hasPreview={Boolean(previewSrc)}
      $loading={loading}
      onDragLeave={(event) => {
        event.preventDefault()
        setAsActive(false)
      }}
      onDragOver={(event) => {
        event.preventDefault()
        setAsActive(true)
      }}
      onDrop={(event) => {
        event.preventDefault()
        setAsActive(false)
        onDrop(event)
      }}
      {...labelProps}
    >
      {previewSrc ? (
        <>
          <imageUploader.MiniDeletionOverlay
            onClick={(event) => {
              event.preventDefault()
              onRemove(event)
            }}
          >
            <glyphs.stroke.Trash size={24} />
          </imageUploader.MiniDeletionOverlay>
          <imageUploader.MiniPreview src={previewSrc} />
        </>
      ) : (
        <>{!loading && <glyphs.stroke.Image size={24} />}</>
      )}

      <Spinner small />

      {!previewSrc && (
        <S.imageUploader.InvisibleInput
          disabled={disabled || loading}
          accept="image/*"
          type="file"
          id={id ?? stableId}
          onChange={onChange}
        />
      )}
    </imageUploader.MiniWrapper>
  )
}

export const MiniImageUploader = styled(MiniImageUploaderComponent)<MiniImageUploaderProps>``
